import { useRequestHeaders } from '#imports'

/**
 * 标准化 UA 字符串，避免大小写/空白导致匹配不一致。
 */
export const normalizeUserAgent = (input?: string): string => {
    return String(input || '').trim().toLowerCase()
}

/**
 * 搜索爬虫与 SEO 常见抓取器识别。
 * 默认：空 UA 返回 false，避免误判普通流量。
 */
export const isSearchBot = (userAgent?: string): boolean => {
    const ua = normalizeUserAgent(userAgent)
    if (!ua) return false

    return /(googlebot|google-inspectiontool|googleother|adsbot-google|apis-google|bingbot|adidxbot|duckduckbot|slurp|baiduspider|yandex(?:bot|images|mobile)?|sogou|exabot|facebot|ia_archiver|applebot|petalbot|semrushbot|ahrefsbot|mj12bot|twitterbot|linkedinbot)/i.test(
        ua
    )
}

/**
 * 在 Nuxt 运行时读取当前请求/浏览器 UA。
 */
export const getRequestUserAgent = (): string => {
    if (import.meta.server) {
        const headers = useRequestHeaders(['user-agent'])
        return String(headers['user-agent'] || '')
    }

    if (typeof navigator !== 'undefined') {
        return navigator.userAgent
    }

    return ''
}
